/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Outro_SuffixInputs */

const en_privacy_rights_outro_suffix = /** @type {(inputs: Privacy_Rights_Outro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. We will respond within 30 days.`)
};

const de_privacy_rights_outro_suffix = /** @type {(inputs: Privacy_Rights_Outro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Wir werden innerhalb von 30 Tagen antworten.`)
};

const fr_privacy_rights_outro_suffix = /** @type {(inputs: Privacy_Rights_Outro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Nous répondrons dans les 30 jours.`)
};

const es_privacy_rights_outro_suffix = /** @type {(inputs: Privacy_Rights_Outro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Responderemos en un plazo de 30 días.`)
};

const it_privacy_rights_outro_suffix = /** @type {(inputs: Privacy_Rights_Outro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Risponderemo entro 30 giorni.`)
};

const nl_privacy_rights_outro_suffix = /** @type {(inputs: Privacy_Rights_Outro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Wij reageren binnen 30 dagen.`)
};

const pl_privacy_rights_outro_suffix = /** @type {(inputs: Privacy_Rights_Outro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Odpowiemy w ciągu 30 dni.`)
};

const fi_privacy_rights_outro_suffix = /** @type {(inputs: Privacy_Rights_Outro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Vastaamme 30 päivän kuluessa.`)
};

const da_privacy_rights_outro_suffix = /** @type {(inputs: Privacy_Rights_Outro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Vi svarer inden for 30 dage.`)
};

const sv_privacy_rights_outro_suffix = /** @type {(inputs: Privacy_Rights_Outro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Vi svarar inom 30 dagar.`)
};

/**
* | output |
* | --- |
* | ". We will respond within 30 days." |
*
* @param {Privacy_Rights_Outro_SuffixInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_outro_suffix = /** @type {((inputs?: Privacy_Rights_Outro_SuffixInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Outro_SuffixInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_outro_suffix(inputs)
	if (locale === "fr") return fr_privacy_rights_outro_suffix(inputs)
	if (locale === "es") return es_privacy_rights_outro_suffix(inputs)
	if (locale === "it") return it_privacy_rights_outro_suffix(inputs)
	if (locale === "nl") return nl_privacy_rights_outro_suffix(inputs)
	if (locale === "pl") return pl_privacy_rights_outro_suffix(inputs)
	if (locale === "fi") return fi_privacy_rights_outro_suffix(inputs)
	if (locale === "da") return da_privacy_rights_outro_suffix(inputs)
	if (locale === "sv") return sv_privacy_rights_outro_suffix(inputs)
	return en_privacy_rights_outro_suffix(inputs)
});